var render = function render(_c,_vm){return _c('svg',_vm._g(_vm._b({staticClass:"icon left-more",class:[_vm.data.class, _vm.data.staticClass],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},'svg',_vm.data.attrs,false),_vm.listeners),[_c('path',{attrs:{"d":"m13.586 12-5.293 5.293a1 1 0 0 0 1.414 1.414l6-6a1 1 0 0 0 0-1.414l-6-6a1 1 0 0 0-1.414 1.414z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }